<cm-drop-files (filesDropped)="handleDroppedFiles($event)" class="cm-drop-files">
    <ng-content></ng-content>
</cm-drop-files>
